import { LostPasswordPostParams } from '@/api/model/authentication/lostpassword.ts';
import { useLostPasswordPost } from '@/api/services/authentication/lostpassword.ts';
import { useMessage } from '@/contexts/message/MessageContext.ts';
import { useTranslations } from '@/contexts/translation/useTranslations';
import useGetAuthentication from '@/domains/authentication/useGetAuthentication.ts';
import useAuthNavigator from '@/pages/authentication/navigation/useAuthNavigator.ts';
import { FormProps } from 'antd';

export interface EmailPasswordRecoveryFieldType {
  email?: string;
  sec_token?: string;
}

interface UseEmailPasswordRecoveryFormProps {
  handleContent: () => void;
}

const useEmailPasswordRecoveryForm = ({
  handleContent,
}: UseEmailPasswordRecoveryFormProps) => {
  const { successMessage, errorMessage } = useMessage();
  const { userType } = useAuthNavigator();
  const { mutate: postLostPassword } = useLostPasswordPost();
  const { data } = useGetAuthentication();
  const { t } = useTranslations({ ns: 'auth' });

  const onFinish: FormProps<EmailPasswordRecoveryFieldType>['onFinish'] = (
    values: Partial<LostPasswordPostParams>,
  ) => {
    if (!values.email || !values.sec_token) {
      return;
    }

    const loginParams: LostPasswordPostParams = {
      email: values.email,
      type: userType,
      sec_token: values.sec_token,
      sendPassword: 'emailPassword',
    };

    postLostPassword(loginParams, {
      onSuccess: () => {
        successMessage({
          content: t(`lostpassword.${userType}.success_message`),
        });
        handleContent();
      },
      onError: (err) => {
        errorMessage({ content: err?.response?.data?.error_message });
      },
    });
  };

  return { onFinish, userType, t, data };
};

export default useEmailPasswordRecoveryForm;
